import digitalPrinting from "./templates/digital-printing";

export default [
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>Пазл размером 435x314мм состоит из 408 элементов. Допускает печать разных файлов и изображений (jpg, tiff, psd, cdr, eps) с минимально допустимым разрешением 300 dpi.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
